import InvestStatementPanel from './InvestStatementPanel';

export default InvestStatementPanel;
